import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center px-4">
      <h1 className="text-7xl font-bold text-secondary">404</h1>
      <h2 className="text-2xl font-semibold mt-4 text-gray-700">Oops! Page Not Found</h2>
      <p className="text-gray-500 mt-2 max-w-md">
        The page you're looking for doesn't exist or has been moved.
      </p>

      <button
        onClick={() => navigate("/")}
        className="mt-6 bg-secondary text-white px-6 py-2 rounded-lg shadow-md hover:bg-secondary-dark transition"
      >
        Go to Homepage
      </button>
    </div>
  );
};

export default NotFound;
